module.exports = __webpack_public_path__ + "static/media/male1.fcaba714.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/assets/body-model/male1.png
// module id = 894
// module chunks = 0